// avstemming-assets-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avce.common.amount': 'Amount',
  'avce.common.date': 'Date',
  'avce.common.type': 'Type',
  'avce.common.account': 'Account',
  'avce.common.status': 'Status',
  'avce.common.difference': 'Difference',
  'avce.common.none': 'None',
  'avce.common.close': 'Close',
  'avce.common.assess': 'Assess',
  'avce.common.viewAssessment': 'View assessment',
  'avce.common.requestDocs': 'Ask the client for documentation',
  'avce.common.incomplete': 'Incomplete',
  'avce.common.notFetched': 'Not retrieved by the app',
  'avce.common.details': 'Details',
  'avce.common.warning': 'Alert',
  'avce.common.voucher': 'Voucher',
  'avce.common.reset': 'Reset',
  'avce.common.all': 'All',
  'avce.common.ofCount': '{done} of {total}',
  'avce.common.documentation': 'Documentation',
  'avce.common.depreciation': 'Depreciation',
  'avce.common.depreciations': 'Depreciation',
  'avce.common.reviewNeeded': 'Needs assessment',
  'avce.common.notRelevant': 'Not relevant',
  'avce.common.matches': 'Matches',
  'avce.derived.possibleCapitalization': 'Possible capitalizable purchases have been assessed',
  'avce.derived.directPosting': 'Direct postings to fixed asset accounts have been assessed',
  'avce.derived.depreciationDiff': 'Depreciation differences have been handled',
  'avce.derived.noDepreciation': 'Assets without calculated depreciation have been handled',
  'avce.derived.possibleDisposal': 'Possible disposals have been examined',
  'avce.derived.registeredDisposal': 'Registered disposals have been checked',
  'avce.derived.gainLoss': 'Gains and losses on disposal have been checked',
  'avce.derived.proceedsNotBooked': 'Proceeds that are not booked have been followed up',
  'avce.derived.missingDocs': 'Missing documentation has been followed up',
  'avce.derived.fullyDepreciated': 'Fully depreciated assets have been assessed',
  'avce.derived.negativeValue': 'Negative book values have been handled',
  'avce.checklist.noPoints': 'No control points are defined for assets in this period.',
  'avce.checklist.title': 'Professional checklist',
  'avce.checklist.titleReadOnly': 'Professional checklist (preparer\'s, read-only)',
  'avce.checklist.scope': 'The points apply to the whole asset area. A tick is saved on all accounts in the area.',
  'avce.checklist.groupItems': 'Items that require handling',
  'avce.checklist.handledOf': '{done} of {total} handled',
  'avce.checklist.notApplicable': 'Not applicable this period',
  'avce.checklist.followsAssessments': 'Follows from the assessments',
  'avce.checklist.groupAssessments': 'Overall professional assessments',
  'avce.checklist.groupRelevance': 'Overall relevance assessment',
  'avce.checklist.relevanceNote': 'Matters the bookkeeping does not see. "Not relevant" is also an answer: there is no assessment to make if the client neither leases, holds assets with a third party nor has pledged any.',
  'avce.checklist.groupReady': 'Readiness',
  'avce.checklist.findingsHandled': '{total} control findings handled: {done} of {total}',
  'avce.checklist.manualProgress': '{done} of {total} manual control points completed',
  'avce.checklist.manualProgressBy': 'Performed by {name} · {done} of {total} manual control points completed',
  'avce.blocker.findings': '{count} control findings have not been fully assessed',
  'avce.blocker.accounts': '{count} fixed asset accounts deviate from the register',
  'avce.blocker.docs': '{count} required documentation is missing',
  'avce.blocker.manualOne': '{count} manual control point remains',
  'avce.blocker.manualMany': '{count} manual control points remain',
  'avce.conclusion.title': 'Conclusion and approval',
  'avce.conclusion.label': 'Conclusion',
  'avce.conclusion.placeholder': 'What does the review of the assets for this period show?',
  'avce.conclusion.savedAs': 'Saved as the justification on the control point «{label}».',
  'avce.conclusion.remainingRisk': 'Remaining risk',
  'avce.conclusion.noRisk': 'Nothing remains that prevents the area from being sent for review. The reconciliation compares two of the entity\'s own sources; physical existence, ownership and impairment have been confirmed manually, not by the bookkeeping.',
  'avce.conclusion.followUp': 'Follow-up next period',
  'avce.conclusion.noFollowUp': 'No assessments are marked for follow-up next period.',
  'avce.conclusion.followedUp': 'Follow up',
  'avce.conclusion.measure': 'Action: {measure}',
  'avce.conclusion.noMeasure': 'No action noted',
  'avce.conclusion.deadline': ' · Deadline {date}',
  'avce.conclusion.openAssessment': 'Open assessment',
  'avce.conclusion.sendToReview': 'Send the area for review',
  'avce.conclusion.oneLeft': 'One thing remains before the area can be sent.',
  'avce.conclusion.manyLeft': '{count} things remain before the area can be sent.',
  'avce.drawer.note.capitalization': 'Assess: does the acquisition have a useful life that makes it capitalizable, is it one asset or several, and do freight and installation belong in the acquisition cost?',
  'avce.drawer.note.depreciation': 'Assess: is the balance group correct, is the depreciation booked in the right year, and are there indications of impairment beyond the ordinary depreciation?',
  'avce.drawer.note.documentation': 'Assess: can the acquisition cost be documented, and what is obtained where the voucher is missing?',
  'avce.drawer.note.disposal': 'Assess: has the asset actually left the business, is the consideration booked, and is the gain or loss (consideration minus book value) treated correctly in the result? For tax, the consideration instead reduces the balance group, and the two must not be mixed.',
  'avce.drawer.note.directPosting': 'Assess: should the posting be on the fixed asset account, and if so should it also go into the fixed asset register so that it is depreciated?',
  'avce.drawer.note.lifetime': 'Assess: does the asset still exist, is it in use, is the residual value reasonable, and should it be retired and removed from the register?',
  'avce.drawer.assetInRegister': ' · Asset in the register',
  'avce.drawer.assessment': 'Assessment',
  'avce.drawer.reason': 'Professional justification',
  'avce.drawer.reasonRequired': 'Professional justification (required)',
  'avce.drawer.reasonPlaceholder': 'What is the matter about, and what is the assessment based on?',
  'avce.drawer.measure': 'Action',
  'avce.drawer.measurePlaceholder': 'E.g. Register the asset, correct the voucher, or ask the client for documentation',
  'avce.drawer.followUpDeadline': 'Follow-up deadline',
  'avce.drawer.followUpNext': 'Follow up next period',
  'avce.drawer.needsReason': 'This assessment requires a justification.',
  'avce.drawer.markDone': 'Mark as assessed',
  'avce.sources.title': 'Data sources',
  'avce.sources.oneIncomplete': '{count} source is not complete for the period.',
  'avce.sources.manyIncomplete': '{count} sources are not complete for the period.',
  'avce.sources.allPresent': 'The sources the reconciliation reads are in place for the period.',
  'avce.sources.colSource': 'Source',
  'avce.sources.complete': 'Complete',
  'avce.main.title': 'Automatic main reconciliation',
  'avce.main.noAccounts': 'No fixed asset account to compare',
  'avce.main.differenceOpen': 'Difference must be handled',
  'avce.main.matches': 'Fixed asset register and general ledger match overall',
  'avce.main.ledgerValue': 'Book value in the general ledger',
  'avce.main.registerValue': 'Book value in the fixed asset register',
  'avce.main.preliminaryDifference': 'Preliminary difference',
  'avce.main.notBookedDepreciation': 'Calculated depreciation not yet booked',
  'avce.main.explainedItems': 'Explained items in the reconciliation',
  'avce.main.unexplainedDifference': 'Unexplained difference',
  'avce.main.comparedOn': 'Compared on {accounts}.',
  'avce.main.explanation': 'Book value in the general ledger is the fixed asset accounts minus the accumulated depreciation. The balance reconciliation compares two of the entity\'s own sources; the existence, classification, depreciation and documentation of the assets are determined by the controls below, not by the two figures being equal.',
  'avce.main.cost': 'Acquisition cost',
  'avce.main.accumulated': 'Accumulated depreciation',
  'avce.main.bookValueRegister': 'Book value in the register',
  'avce.main.activeAssets': 'Assets in use',
  'avce.main.yearDepreciation': 'Calculated depreciation {year}',
  'avce.main.additionsYtd': 'Additions so far in {year}',
  'avce.main.disposalsPeriod': 'Disposals in the period',
  'avce.main.itemsNeedAssessment': 'Matters requiring assessment',
  'avce.main.openRegister': 'Open the fixed asset register',
  'avce.main.seeDepreciation': 'See the depreciation',
  'avce.main.seeControlAccounts': 'See the control accounts',
  'avce.accounts.notCompared': 'Not compared',
  'avce.accounts.title': 'Control accounts in the general ledger',
  'avce.accounts.none': 'No fixed asset account exists in this period.',
  'avce.accounts.hint': 'Click an account with assets to see which assets the register has on it.',
  'avce.accounts.colAccount': 'Control account',
  'avce.accounts.colOpening': 'Opening balance',
  'avce.accounts.colAdditions': 'Additions',
  'avce.accounts.colDisposals': 'Disposals',
  'avce.accounts.colClosing': 'Closing balance',
  'avce.accounts.colRegisterValue': 'Register value',
  'avce.accounts.accumulatedNote': 'Accumulated depreciation. The register\'s accumulated depreciation includes the year\'s calculated amount, which is only booked in the year-end closing, so the account is therefore not compared directly.',
  'avce.accounts.costNote': 'Compared with acquisition cost in the register',
  'avce.accounts.sumCost': 'Total acquisition cost in the fixed asset register',
  'avce.accounts.ledgerBalance': 'General ledger balance, account {code}',
  'avce.accounts.unexplained': 'Unexplained difference: see the acquisitions and direct postings',
  'avce.tile.possibleCapitalization': 'Possible capitalizable purchases',
  'avce.tile.depreciationDiff': 'Depreciation differences',
  'avce.tile.missingDocs': 'Missing documentation',
  'avce.tile.noDepreciation': 'Without calculated depreciation',
  'avce.tile.fullyDepreciated': 'Fully depreciated assets',
  'avce.tile.possibleDisposals': 'Possible disposals without registration',
  'avce.tile.directPostings': 'Direct postings to fixed asset accounts',
  'avce.tile.negativeValues': 'Negative book values',
  'avce.controlCard.title': 'Control card',
  'avce.controlCard.progress': '{checks} automatic checks run · manually assessed {done} of {total}',
  'avce.controlCard.registerVsLedger': 'Fixed asset register vs general ledger',
  'avce.controlCard.accountsCompared': '{count} accounts compared',
  'avce.controlCard.activeFilter': 'Active filter: {label} · {count} items',
  'avce.checks.title': 'Automatic checks',
  'avce.checks.note': 'The checks do not tick anything in the professional checklist. They say what the person ticking should have looked at. Impairment, ownership and physical existence cannot be read from the bookkeeping and are therefore among the manual points.',
  'avce.checks.colCheck': 'Check',
  'avce.checks.colRun': 'Run',
  'avce.checks.colFindings': 'Findings',
  'avce.checks.run': 'Run',
  'avce.checks.found': '{count} findings',
  'avce.checks.noFindings': 'No findings',
  'avce.depr.notBookedYet': 'Not booked yet',
  'avce.assetStatus.active': 'In use',
  'avce.assetStatus.writtenOff': 'Fully depreciated',
  'avce.assetStatus.sold': 'Sold',
  'avce.register.title': 'Fixed asset register',
  'avce.register.intro': 'The register is the app\'s own. Booked depreciation follows useful life and residual value per asset; tax balance is calculated separately per group.',
  'avce.register.note': 'Plumme calculates the amount from the plan, but does not choose useful life, residual value or whether impairment exists. The professional choices must be documented, and a missing plan or annual impairment assessment remains as a deviation.',
  'avce.register.colAsset': 'Asset',
  'avce.register.colGroup': 'Balance group',
  'avce.register.colAcquired': 'Acquired',
  'avce.register.colLife': 'Useful life',
  'avce.register.colDepreciation': 'Depreciation {year}',
  'avce.register.colAccumulated': 'Acc. depreciation',
  'avce.register.colBookValue': 'Book value',
  'avce.register.years': '{years} years',
  'avce.register.empty': 'No assets match the filters.',
  'avce.acq.title': 'Acquisitions and capitalization check',
  'avce.acq.kpiAnalyzed': 'Purchases analyzed',
  'avce.acq.kpiOverThreshold': 'Over the threshold',
  'avce.acq.kpiCapitalized': 'Capitalized in the period',
  'avce.acq.kpiDirect': 'Posted directly to fixed asset account',
  'avce.acq.noThreshold': 'The capitalization threshold is a Norwegian tax rule. The accounting country is {country}, and Plumme has no corresponding threshold to check against here.',
  'avce.acq.threshold': 'The threshold is {amount} with at least {years} years of useful life, and applies to ONE asset, not the invoice total. It is a control signal: Plumme does not decide that a purchase must be capitalized, and a smaller purchase may be capitalizable if the useful life is long enough.',
  'avce.acq.colSupplier': 'Supplier',
  'avce.acq.colDescription': 'Description',
  'avce.acq.colDeductibleVat': 'Deductible VAT',
  'avce.acq.colTreatment': 'Treatment',
  'avce.acq.capitalized': 'Capitalized',
  'avce.acq.expensed': 'Expensed',
  'avce.acq.empty': 'No purchases in the period are large enough to be checked against the threshold.',
  'avce.depr.kpiBookedYtd': 'Booked so far this year',
  'avce.depr.kpiDeviatingGroups': 'Balance groups with deviations',
  'avce.depr.kpiWithoutPlan': 'Assets without calculated depreciation',
  'avce.depr.note': 'Depreciation is booked in the year-end closing, not monthly. A difference early in the year therefore usually just means the year has not ended: it is a control point, not a deviation in itself.',
  'avce.depr.colRate': 'Rate',
  'avce.depr.colAssets': 'Assets',
  'avce.depr.colExpenseAccount': 'Expense account',
  'avce.depr.colCalculated': 'Calculated depreciation',
  'avce.depr.colBooked': 'Booked depreciation',
  'avce.depr.empty': 'No balance groups with assets or booked depreciation.',
  'avce.disposals.title': 'Sales and retirements',
  'avce.disposals.kpiRegistered': 'Registered disposals',
  'avce.disposals.kpiUnregistered': 'Possible unregistered disposals',
  'avce.disposals.kpiGainReview': 'Gain/loss to check',
  'avce.disposals.kpiNoVoucher': 'Registered disposals without voucher',
  'avce.disposals.registerProceeds': 'Consideration in the fixed asset register',
  'avce.disposals.bookedProceeds': 'Booked sale proceeds on {accounts}',
  'avce.disposals.computedGain': 'Calculated gain/loss (register)',
  'avce.disposals.bookedNet': 'Booked net on the disposal accounts',
  'avce.disposals.note': 'The gain is the consideration minus book value at disposal. If the depreciation is not booked, the offsetting account carries the whole acquisition cost, and booked net becomes lower than the calculated gain; the difference is then the same depreciation that appears as its own line in the main reconciliation. For tax, the disposal is treated in the balance group, not as a gain.',
  'avce.disposals.colAssetOrPosting': 'Asset or posting',
  'avce.disposals.colProceeds': 'Consideration',
  'avce.disposals.colBookValueAtDisposal': 'Book value at disposal',
  'avce.disposals.colGain': 'Calculated gain/loss',
  'avce.disposals.voucherNo': 'Voucher {number}',
  'avce.disposals.registeredInPeriod': 'Registered in the period',
  'avce.disposals.empty': 'No disposals or credit postings on the fixed asset accounts in the period.',
  'avce.flag.possibleCapitalization': 'Possible capitalizable purchase',
  'avce.flag.directPosting': 'Direct posting to fixed asset account',
  'avce.flag.depreciationDiff': 'Depreciation difference',
  'avce.flag.noDepreciation': 'No depreciation calculated',
  'avce.flag.missingBookPlan': 'Missing accounting depreciation plan',
  'avce.flag.missingImpairment': 'Missing annual impairment assessment',
  'avce.flag.fullyDepreciated': 'Fully depreciated: still in the register',
  'avce.flag.possibleDisposal': 'Possible disposal not registered',
  'avce.flag.disposalRegistered': 'Disposal registered in the period',
  'avce.flag.negativeValue': 'Negative book value',
  'avce.flag.gainReview': 'Gain/loss requires checking',
  'avce.flag.proceedsNotBooked': 'Consideration not booked',
  'avce.assess.notAssessed': 'Not assessed',
  'avce.assess.noCorrection': 'No correction needed',
  'avce.assess.capitalize': 'Must be capitalized in the fixed asset register',
  'avce.assess.correctlyExpensed': 'Correctly expensed',
  'avce.assess.correctAccount': 'Corrected: posted to the right account',
  'avce.assess.depreciationCorrected': 'Depreciation is corrected',
  'avce.assess.depreciationAccepted': 'Depreciation deviation accepted',
  'avce.assess.registerDisposal': 'Disposal is registered in the fixed asset register',
  'avce.assess.notDisposal': 'Not a disposal',
  'avce.assess.lifetimeConfirmed': 'Still in use: useful life assessed',
  'avce.assess.retire': 'Retired: removed from the register',
  'avce.assess.gainConfirmed': 'Gain/loss checked and correct',
  'avce.assess.bookProceeds': 'Consideration must be booked',
  'avce.assess.impairmentAssessed': 'Impairment assessed',
  'avce.assess.awaitingDocs': 'Awaiting documentation',
  'avce.assess.awaitingClient': 'Awaiting the client',
  'avce.type.capitalization': 'Capitalization',
  'avce.type.disposal': 'Disposal',
  'avce.type.directPosting': 'Direct posting',
  'avce.type.lifetime': 'Useful life and use',
  'avce.quick.done': 'Assessed',
  'avce.quick.newInPeriod': 'New in the period',
  'avce.quick.noDocs': 'Without documentation',
  'avce.quick.disposalInPeriod': 'Disposal in the period',
  'avce.flags.more': '+{count} more',
  'avce.items.intro': 'The items are collected from the fixed asset register, the acquisitions, the depreciation, the disposals and the postings on the fixed asset accounts. The assessment is saved on the reconciliation account and read by the reviewer.',
  'avce.items.clearFilters': 'Reset filters',
  'avce.items.colReference': 'Reference',
  'avce.items.colAssessmentStatus': 'Assessment status',
  'avce.items.empty': 'No items match the filters.',
  'avce.docs.colBasis': 'Basis',
  'avce.docs.inPlace': 'In place',
  'avce.docs.attached': 'Attached documentation',
  'avce.docs.empty': 'No documents have been uploaded in the assets area for this period.',
  'avce.docs.emptyWithUpload': 'No documents have been uploaded in the assets area for this period. Use the documents tab in the right-hand panel to attach them.',
  'avce.page.noAccount': 'The assets area has no reconciliation account in this period.',
  'avce.nav.overview': 'Overview',
  'avce.nav.countDifference': '{count} difference',
  'avce.nav.fixedAssets': 'Fixed assets',
  'avce.nav.countRegistered': '{count} registered',
  'avce.nav.acquisitions': 'Acquisitions',
  'avce.nav.countToAssess': '{count} to assess',
  'avce.nav.countPurchases': '{count} purchases',
  'avce.nav.countFindings': '{count} findings',
  'avce.nav.controlAccounts': 'Control accounts',
  'avce.nav.countMatching': '{matching}/{total} match',
  'avce.nav.deviationsActions': 'Deviations and actions',
  'avce.nav.countMissing': '{count} missing',
  'avce.nav.controlApproval': 'Control and approval',
  'avce.page.assets': 'Assets',
  'avce.page.hintOpen': '{count} items with alerts have not been fully assessed.',
  'avce.page.hintDone': 'All items with alerts have been assessed.',
  'avce.page.title': 'Assets: fixed asset register, general ledger and depreciation',
  'avce.page.responsible': ' · Responsible {name}',
  'avce.page.threshold': ' · Capitalization threshold {amount}',
  'avce.page.itemsNeedAssessment': '{count} items require assessment',
  'avce.page.noOpenItems': 'No open items',
  'avce.page.intro': 'The reconciliation compares the fixed asset register with the general ledger and looks for what never made it into the register.',
  'avce.page.noItemsFlagged': 'No items are flagged for this period.',
  'avce.page.itemsFlagged': '{total} items are flagged, and {open} of them still require an assessment.',
  'avce.page.method': 'Depreciation method',
  'avce.page.methodValue': 'Declining-balance depreciation per balance group',
  'avce.page.hasFixedAssets': 'The entity has fixed assets',
  'avce.page.noneInRegister': 'None in the register',
  'avce.page.yes': 'Yes',
  'avce.page.country': 'Accounting country',
  'avce.page.readThrough': 'Data read through',
  'avce.page.noExternalBalance': 'Assets have no external balance. Both the fixed asset register and the general ledger are the entity\'s own sources, and an asset that was never registered is missing from both. Physical existence, ownership, pledges and impairment are therefore confirmed manually in the checklist, not by the two figures being equal.',
  'avce.page.registerEmpty': 'The fixed asset register is empty for {year}. That does not make the area "not relevant": the controls below still look for larger expensed purchases, postings on the fixed asset accounts and assets from earlier periods. If the area really is not relevant, it is set with a justification in the relevance assessment in the checklist.',
});
